module.exports = __webpack_public_path__ + "static/media/copyActive.caa2a066.svg";